import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=fcd0b562&scoped=true&"
var script = {}
import style0 from "./TabsLayout.vue?vue&type=style&index=0&id=fcd0b562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd0b562",
  null
  
)

export default component.exports